export default {
  computed: {
    bannerChannel() {
      return this.$route.meta.channel === 'bookshelf' ? 'bookshelf' : 'eshop';
    },
    bannerTitle() {
      return this.bannerChannel === 'bookshelf'
        ? 'Bookshelf Banners'
        : 'Banners';
    },
  },
  metaInfo() {
    return { title: this.bannerTitle };
  },
  methods: {
    bannerRoute(action) {
      const section = this.bannerChannel === 'bookshelf' ? 'bookshelf' : 'home';
      return `content.${section}.banners.${action}`;
    },
  },
};
